module.exports = __webpack_public_path__ + "static/media/linea_iptv_icon.41d6fbf0.svg";